import { useState } from 'react';
import { History } from 'lucide-react';
import { Button } from '../ui/button';
import { K2ArticleHistory } from './K2ArticleHistory';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { SimpleTable } from './K2Tables';
import { fmtCz, fmtKc } from './k2utils';
import { fmtQty } from './itemsUtils';

const LINE_COLUMNS = [
  { key: 'date', label: 'Datum', render: (r) => fmtCz(r.date), className: 'whitespace-nowrap' },
  { key: 'doc', label: 'Doklad', className: 'font-medium whitespace-nowrap' },
  { key: 'book', label: 'Řada' },
  { key: 'warehouse', label: 'Sklad' },
  { key: 'quantity', label: 'Množství', num: true, render: (r) => <span className={r.quantity < 0 ? 'text-[#16A34A]' : ''}>{fmtQty(r.quantity, r.unit)}</span> },
  { key: 'value', label: 'Hodnota', num: true, render: (r) => <span className={r.value < 0 ? 'text-[#16A34A]' : 'font-semibold'}>{fmtKc(r.value)}</span> },
];

export const K2ItemDetail = ({ article, onClose }) => {
  const [hist, setHist] = useState(null);
  return (
  <Dialog open={!!article} onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="max-w-4xl max-h-[85vh] overflow-y-auto" data-testid="k2-item-detail">
      {article && (
        <>
          <DialogHeader>
            <DialogTitle className="font-['Manrope'] text-[#052E16] flex flex-wrap items-center gap-3 pr-8" data-testid="k2-item-detail-title">
              <span>{article.name} <span className="text-sm font-normal text-[#57534E]">({article.code})</span></span>
              <Button size="sm" variant="outline" onClick={() => setHist({ code: article.code, name: article.name })} data-testid="k2-item-history-btn">
                <History className="w-4 h-4 mr-1" /> Celá historie
              </Button>
            </DialogTitle>
          </DialogHeader>
          <div className="grid grid-cols-3 gap-3 text-sm">
            <div className="p-3 rounded-xl bg-[#FEF2F2]"><div className="text-xs text-[#57534E]">Odepsáno</div><div className="font-bold text-[#DC2626]">{fmtQty(article.wq, article.unit)} · {fmtKc(article.wv)}</div></div>
            <div className="p-3 rounded-xl bg-[#F0FDF4]"><div className="text-xs text-[#57534E]">Přebytek</div><div className="font-bold text-[#16A34A]">{fmtQty(article.sq, article.unit)} · {fmtKc(article.sv)}</div></div>
            <div className="p-3 rounded-xl bg-[#F8FAF8]"><div className="text-xs text-[#57534E]">Čistě</div><div className="font-bold text-[#052E16]">{fmtQty(article.nq, article.unit)} · {fmtKc(article.nv)}</div></div>
          </div>
          <SimpleTable testId="k2-item-lines" columns={LINE_COLUMNS} rows={[...article.lines].sort((a, b) => b.date.localeCompare(a.date))} rowKey={(r) => r.rid} />
          <K2ArticleHistory article={hist} onClose={() => setHist(null)} />
        </>
      )}
    </DialogContent>
  </Dialog>
  );
};
